export const name = 'AcceptExistingUserController';

export default function AcceptExistingUserController(
  rnInvitation,
  rnAuthService,
  rnSession,
  $analytics,
  $state,
  $window,
  $stateParams
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const EVENT_NAME='accept invitation';
  const EVENT_CATEGORY='account';

  let analyticsEvent;
  let contexts;
  let myParams = {};
  let invitationId;

  let vm = this;
  vm.loading = true;
  vm.submitting = false;

  // controller functions
  vm.submit = submit;
  vm.cancel = cancel;
  vm.go = go;

  vm.unitTest = {
    getMyParams: function() {return myParams;},
    handleAcceptError: handleAcceptError
  };

  activate();

  ////////////////////////
  function activate() {
    parseParams();
    getInvitation(invitationId).finally(() => {
      vm.loading = false;
    });
  }

  function parseParams() {
    myParams.data = $stateParams.data;
    if ($stateParams.bu) {
      myParams.bu = $stateParams.bu;
      vm.bu = $stateParams.bu;
    }

    invitationId = $stateParams.invitationId;
    if (!invitationId || invitationId === '') {
      // fall back to what is stored in state data
      invitationId = _.get(myParams, 'data.invitationId', undefined);
    }

    if (!invitationId) {
      // If we don't have an invitation id we can abort and drop state
      $state.go('signin', {signout: true});
    }
  }

  function getInvitation(invitationId) {
    return rnInvitation.getById(invitationId).then(invitation => {
      vm.invitation = invitation;

      analyticsEvent = {
        category: 'account',
        label: vm.invitation.invitationType + " - " + vm.invitation.organizationType,
        value: vm.invitation.roleId,
      };

      if (invitation.status !== 'Pending') {
        vm.invalid = true;
        vm.invalidKey = 'register.register.Invitation_Error_' + invitation.status;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
      }
    })
      .catch((error) => {
        vm.invalid = true;
        vm.invalidActionKey = 'register.register.AcceptUser_Error_Action_General';
        if (error === 404) {
          vm.invalidKey = 'register.register.Invitation_Error_Retrieve_NotFound';
        }
        else {
          vm.invalidKey = 'register.register.Invitation_Error_Retrieve';
        }
      });
  }

  function submit() {
    let url = vm.invitation._links.accept.href;
    vm.submitting = true;
    delete vm.errorKey;

    rnInvitation.acceptInvitationWithExistingUser(vm.invitation._links.accept.href, vm.invitation._links.accept.op).then((data) => {
      getContexts().finally(() => {
        $analytics.eventTrack(EVENT_NAME, analyticsEvent);
        vm.success = true;
      });
    })
      .catch((error) => {
        handleAcceptError(error);
      })
      .finally(() => {
        vm.submitting = false;
      });
  }

  function getContexts() {
    return rnSession.availableContexts().then(data => {
      contexts = data.contexts;
    });
  }

  function handleAcceptError(error) {
    let statusCode = _.get(error, 'smsError.statusCode', -1);

    switch(statusCode) {
      case 404:
        vm.errorKey = 'register.register.Invitation_ErrorCode_NotFound';
        break;
      case 409:
        if (myParams.data.username) {
          vm.errorKey = 'register.register.User_Name_Conflict';
        }
        else {
          vm.errorKey = 'register.register.Invitation_ErrorCode_User_Already_Member';
        }
        break;
      case 498:
        vm.errorKey = 'register.register.Invitation_ErrorCode_Expired';
        break;
      default:
        vm.errorKey = 'register.register.Error_Accepting_Invitation';
    }

    // $analytics.exceptionTrack() in the future
    ga('send', 'exception', {
      exDescription: EVENT_NAME + " failed: " + _.get(error, 'smsError.message', 'unknown')
    });
  }

  function cancel() {
    $state.go('signin', {signout: true});
  }

  function go() {
    let found = _.find(contexts, {name: vm.invitation.organizationName});

    let params = {
      forward: true,
      data: {
        orgId: vm.invitation.senderOrganizationId
      }
    };

    if (found) {
      rnSession.switchContext(found).then(() => {
        $state.go('signin', params);
      });
    }
    else {
      $state.go('signin', params);
    }
  }
}



// WEBPACK FOOTER //
// ./components/accept/user/accept-existing-user.controller.js